import styled, { css } from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export interface SourceStyledProps {
  $size?: 'small' | 'medium'
}

const sizeStyles = {
  small: css`
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
    gap: 6px;
  `,
  medium: css`
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    gap: 8px;
  `,
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<SourceStyledProps>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  line-height: ${({ theme }) => theme.typography.lineHeight.normal};
  margin-top: 16px;

  ${({ $size = 'small' }) => sizeStyles[$size]}

  ${media.tabletDown} {
    font-size: ${({ theme }) => theme.typography.fontSize.label};
    gap: 6px;
  }
`

export const Label = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.tertiary};
`

export const SourceList = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
`
